import type { Settings } from '~/src/types';

export const getTypedNumberFromRange = (
  number: number,
  min: number,
  max: number
) => {
  if (number < min) {
    return min;
  }

  if (number > max) {
    return max;
  }

  return number;
};

export const getTypedBorderRadius = (borderRadius?: number) => {
  const defaultValue = 0;
  const min = 0;
  const max = 30;

  return getTypedNumberFromRange(borderRadius ?? defaultValue, min, max);
};

export const getTypedFontSize = (fontSize?: number) => {
  const defaultValue = 16;
  const min = 12;
  const max = 16;

  return getTypedNumberFromRange(fontSize ?? defaultValue, min, max);
};

export const getCornerStyleBorderRadius = (
  cornerStyle?: Settings['cornerStyle'],
  customBorderRadius?: number
) => {
  const defaultBorderRadius = 4;

  switch (cornerStyle) {
    case 'round':
      return 4;
    case 'square':
      return 0;
    case 'pill':
      return 30;
    case 'custom':
      return customBorderRadius ?? defaultBorderRadius;
    default:
      return defaultBorderRadius;
  }
};

export const sharedClickstreamDimensions = {
  applicationId: 'STORE_FRONT_WEBSITE',
  project_id: 'rosette-elements',
  schemaName: 'exs-elements-schema',
  resolveClickStreamTenantArn: undefined,
};
